<template>
  <div class="question-rating">
    <span class="md-title">{{ question }}</span>
    <rate class="rate" :length="rate" v-model="value" @click.native="event" :ratedesc="['Nada Satisfeito', 'Pouco Satisfeito', 'Moderadamente Satisfeito', 'Satisfeito', 'Muito Satisfeito']"></rate>
    <transition name="zoom">
      <md-field>
        <label v-if="!bad">Comentários</label>
        <label v-if="bad">{{ comment }}<i>*</i></label>
        <md-textarea v-model="context"></md-textarea>
      </md-field>
    </transition>
  </div>
</template>

<script>

export default {
  props: ['question', 'badValue', 'rate', 'comment'],
  model: {
    prop: 'value',
    event: 'change'
  },
  name: 'question-rating',
  data () {
    return {
      value: '',
      context: '',
      bad: false
    }
  },
  computed: {
    isValid () {
      this.$emit('changeData', this.context)
      if (this.bad) {
        return this.context !== ''
      } else {
        return this.value !== ''
      }
    }
  },
  methods: {
    event () {
      this.$emit('change', this.value)
      this.bad = this.value <= this.badValue
      this.$emit('isValid', this.isValid)
    }
  },
  watch: {
    context (val) {
      this.$emit('isValid', this.isValid)
    },
    bad (val) {
      this.$emit('changeData', this.context)
      // if (!val) {
      //   this.$emit('changeData', this.context)
      // } else {
      //   this.$emit('changeData', this.context)
      // }
    }
  }
}
</script>

<style lang="scss">
.question-rating {
  padding: 20px 20px;
  text-align: left;
}
.question {
  margin: 20px 20px;
}
.rate {
  margin: 20px 50px;
  text-align: center;
}
</style>
